import {
  FETCH_PERMISSIONS,
  FETCH_ROLES,
  FETCH_ROLE_PERMISSION_LINKS,
  FETCH_ACTIVE_PERMISSIONS,
  FETCH_NESTED_CATEGORIES
} from "./types";
import SchoolService from "../services/SchoolService";
import AlertService from "../services/AlertService";

export const fetchPermissions = () => {
  return async (dispatch) => {
    let response = await SchoolService.searchPermissions({isSchoolControlled: true});
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({ type: FETCH_PERMISSIONS, payload: response });
    }
  };
};

export const fetchRoles = () => {
  return async (dispatch) => {
    let response = await SchoolService.getAllRoles();
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({ type: FETCH_ROLES, payload: response });
    }
  };
};

// Return a list of objects
// Each object will have a role and the list of permissions granted to that role
export const fetchRolePermissionLinks = () => {
  return async (dispatch) => {
    let response = await SchoolService.getAllRolePermissionLinks();
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({ type: FETCH_ROLE_PERMISSION_LINKS, payload: response });
    }
  };
};

export const fetchActivePermissions = () => {
  return async (dispatch) => {
    let response = await SchoolService.getAllActivePermissions();
    if (response) {
      dispatch({ type: FETCH_ACTIVE_PERMISSIONS, payload: response });
    }
  };
};

export const fetchNestedCategories = () => {
  return async (dispatch) => {
    const categories = await SchoolService.getNestedCategories();
    if(categories){
      dispatch({type: FETCH_NESTED_CATEGORIES, payload: categories})
    }
  }
}

export const batchAddAndDeleteRolePermissionLinks = (addLinks, deleteLinks) => {
  return async (dispatch) => {
    if (addLinks.length > 0) {
      await SchoolService.batchAddRolePermissionLinks(addLinks);
    }
    if (deleteLinks.length > 0) {
      await SchoolService.batchDeleteRolePermissionLinks(deleteLinks);
    }

    // Reset the RolePermissionLinks
    let response = await SchoolService.getAllRolePermissionLinks();
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({ type: FETCH_ROLE_PERMISSION_LINKS, payload: response });
    }
    // Reset the active permissions
    response = await SchoolService.getAllActivePermissions();
    if (response.message) {
      console.log(response.message);
    } else {
      dispatch({ type: FETCH_ACTIVE_PERMISSIONS, payload: response });
    }
    AlertService.addSuccessAlert("Permissions were updated successfully");
  };
};
